import { useEffect, useReducer } from 'react';
import { Link } from 'react-router-dom';

import { getEnv } from '../../lib/env';
import { getTestProps } from '../../lib/helpers';

import {
  CloseIcon,
  FlotiqBadgeLogo,
  FlotiqLogo,
  MenuIcon,
} from '../../images/shapes';

import LinkButton from '../LinkButton/LinkButton';
import MobileTopNavItems from './MobileTopNavItems/MobileTopNavItems';
import TopNavPopover from './TopNavPopover/TopNavPopover';

const linkClasses =
  'pl-2 pr-3 xl:pr-5 2xl:pr-8 py-4 ' +
  'hover:no-underline hover:text-blue focus:no-underline focus:text-blue';

const TopNavbar = ({ mainItems, sideItems, testId }) => {
  const [open, toggleOpen] = useReducer((open) => !open, false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024 && open) toggleOpen();
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [open]);

  return (
    <nav
      className="fixed top-0 flex items-center w-full z-20 font-bold pl-6 pr-2 py-4 lg:px-6 xl:px-14 lg:py-4 group
                transition-colors bg-white dark:bg-gray-900 data-[state=open]:bg-indigo-950
                dark:data-[state=open]:bg-indigo-950"
      data-state={open ? 'open' : 'closed'}
    >
      <div className="mr-4 lg:mr-8 xl:mr-16">
        <Link
          to={getEnv('REACT_APP_FLOTIQ_PAGE_URL')}
          className="cursor-pointer"
          rel="noreferrer"
          {...getTestProps(testId, `logo`)}
        >
          {open ? (
            <FlotiqBadgeLogo className="h-7 lg:h-9" />
          ) : (
            <FlotiqLogo className="h-7 lg:h-9" />
          )}
        </Link>
      </div>

      <div className="hidden lg:flex items-center w-full">
        {mainItems.map(({ key, label, url, items, isFeatures }) =>
          url ? (
            <Link
              className={linkClasses}
              key={key}
              to={url}
              {...getTestProps(testId, `link-${key}`)}
            >
              {label}
            </Link>
          ) : (
            <TopNavPopover
              key={key}
              label={label}
              items={items}
              isFeatures={isFeatures}
              {...getTestProps(testId, `popover-${key}`, 'testId')}
            />
          ),
        )}

        {sideItems.map(({ key, label, url }, index) => (
          <Link
            className={`${linkClasses} ${index === 0 ? 'ml-auto' : ''}`}
            key={key}
            to={url}
            {...getTestProps(testId, `link-${key}`)}
          >
            {label}
          </Link>
        ))}

        <LinkButton
          buttonSize="sm"
          to="/register"
          additionalClasses="rounded-[50px]"
          {...getTestProps(testId, `signup`)}
        >
          Start for free
        </LinkButton>
      </div>

      <div className="flex lg:hidden ml-auto">
        <LinkButton
          buttonSize="sm"
          to="/register"
          additionalClasses="rounded-[50px] h-8"
        >
          Get Flotiq
        </LinkButton>

        <button
          className="pl-2.5"
          onClick={toggleOpen}
          aria-label={open ? 'close menu' : 'open menu'}
          {...getTestProps(testId, 'open-mobile-menu')}
        >
          {open ? (
            <CloseIcon className="w-4 text-white mx-2" />
          ) : (
            <MenuIcon className="w-8" />
          )}
        </button>
      </div>

      <MobileTopNavItems
        mainItems={mainItems}
        sideItems={sideItems}
        {...getTestProps(testId, 'mobile-menu', 'testId')}
      />
    </nav>
  );
};

export default TopNavbar;
